import { gEnums } from '../../enums/globalEnums';
import { updateFirestoreData } from '../../firestoreData/updates/dataUpdates';
import { grts, responseReducers } from './reducerHelpers/dispatchProps';

const rts = {
  handleCommitData: 'handleCommitData',
  handleGolfCourseSearch: 'handleGolfCourseSearch',
  handleUrlSearch: 'handleUrlSearch',
  handleHotelSearch: 'handleHotelSearch',
  handleUpdateFirestoreFromPaste: 'handleUpdateFirestoreFromPaste',
  handleUpdatePasteFromFirestore: 'handleUpdatePasteFromFirestore',
  ...grts
}

export const apiReducer = (state, action) => {

  const { paps_state, viewItem, updateData, page_fns, appSettings_fns, mainDb, fn_cls } = state
  const { type, dispatch, apiResult, view } = action

  switch (type) {

    case rts.handleCommitData:

      const ufProps = {
        dataUpdateType: gEnums.dataUpdateTypes.mergeData,
        allInfo: updateData,
        itemData: updateData,
        vit: viewItem ? viewItem.key : null,
        view: view
      }

      if (ufProps.dataUpdateType) {
        updateFirestoreData(dispatch, paps_state, ufProps, page_fns, null, null, null, null, appSettings_fns, mainDb, fn_cls)
      }

      return { ...state }

    case rts.handleGolfCourseSearch:
      return {
        ...state,
        updateData: apiResult,
        apiResult: apiResult,
        holes: apiResult.holes,
      }

    case rts.handleUrlSearch:
      return {
        ...state,
        updateData: apiResult,
        apiResult: apiResult,
      }

    case rts.handleHotelSearch:
      return {
        ...state,
        updateData: apiResult,
        apiResult: apiResult,
      }

    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const apiInitialState = (paps_state, viewItem, viewListData, page_fns) => {
  return { paps_state, viewItem, viewListData, page_fns }
};

export const apiHandlers = (dispatch, fsCall) => {
  return {
    handleCommitData: (view) => { dispatch({ type: rts.handleCommitData, dispatch, view }) },
    handleSuccess: (fn_response) => { dispatch({ type: rts.handleSuccess, dispatch, fn_response }) },
    handleError: (fn_response) => { dispatch({ type: rts.handleError, dispatch, fn_response }) },
  }
}